import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-neutral-900 text-white"
}
const _hoisted_2 = { class: "sm:pt-7" }
const _hoisted_3 = {
  key: 0,
  class: "font-light text-base sm:text-xl px-2 sm:px-0 py-1"
}
const _hoisted_4 = { class: "aspect-w-16 aspect-h-9" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "px-2 sm:px-0 py-4" }
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = { class: "text-base sm:text-lg" }
const _hoisted_10 = { class: "flex items-center justify-center" }
const _hoisted_11 = { class: "bg-gray-100 mb-6" }
const _hoisted_12 = { class: "px-2 sm:px-0 py-4 md:py-8" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_video_details_completion_button = _resolveComponent("video-details-completion-button")!
  const _component_video_details_bookmark_button = _resolveComponent("video-details-bookmark-button")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_video_details_category = _resolveComponent("video-details-category")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      (_ctx.store.state.video.videoDetails)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.store.state.video.videoDetails.embed_url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_layouts_auth_width, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        (_ctx.store.state.video.videoDetails.role)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.store.state.video.videoDetails.role.name), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("iframe", {
                            src: _ctx.embedSrc,
                            width: "100%",
                            height: "100%",
                            frameborder: "0",
                            allow: "autoplay; fullscreen; picture-in-picture"
                          }, null, 8, _hoisted_5)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.store.state.video.videoDetails.title), 1)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_video_details_completion_button, {
                                isCompleted: _ctx.isCompleted,
                                class: "mr-2"
                              }, null, 8, ["isCompleted"]),
                              _createVNode(_component_video_details_bookmark_button, { isBookmarked: _ctx.isBookmarked }, null, 8, ["isBookmarked"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_layouts_auth_width, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", {
                      class: "v-html whitespace-pre-wrap",
                      innerHTML: _ctx.store.state.video.videoDetails.body
                    }, null, 8, _hoisted_13)
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_layouts_auth_width, null, {
                default: _withCtx(() => [
                  _createVNode(_component_video_details_category, {
                    categories: _ctx.store.state.video.videoDetails.video_categories
                  }, null, 8, ["categories"])
                ]),
                _: 1
              })
            ])
          ], 64))
        : (_openBlock(), _createBlock(_component_layouts_auth_width, { key: 1 }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "padding-auth-contents" }, " 動画が見つかりませんでした。 ", -1)
            ]))]),
            _: 1
          }))
    ]),
    _: 1
  }))
}